import React from "react";
import { Link } from "react-router-dom";

const HeroBanner = () => {
  return (
    <>
      <section className="hero">
        <div className="hero-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>

        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="hero-badge">
                <i className="fas fa-building-columns me-2" /> Licensed
                Corporate Business Correspondent
              </div>

              <h1 className="hero-title">
                Empowering Financial{" "}
                <span className="highlight">Inclusion</span> Across India
              </h1>

              <p className="hero-description">
                FORMAX MONEY, a unit of{" "}
                <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>, is a
                bank-licensed Business Correspondent enabling BC Agents with
                <strong> AEPS, DMT, CMS, UPI Cash Point</strong> &amp; more.
              </p>

              <div className="hero-buttons">
                <a href="/contact-us" className="btn btn-gold">
                  <i className="fas fa-rocket me-2" /> Become a BC Agent
                  <span className="btn-effect"></span>
                </a>
              </div>

              <div className="hero-trust-badges">
                <div className="trust-badge">
                  <i className="fas fa-check-circle"></i>
                  <span>Bank Licensed</span>
                </div>
                <div className="trust-badge">
                  <i className="fas fa-shield-alt"></i>
                  <span>RBI Compliant</span>
                </div>
                <div className="trust-badge">
                  <i className="fas fa-rupee-sign"></i>
                  <span>PAN India Services</span>
                </div>
                <div className="trust-badge">
                  <i className="fas fa-headset"></i>
                  <span>24/7 Support</span>
                </div>
              </div>

              {/* Stats Row */}
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">10K+</div>
                  <div className="stat-label">Active BC Agents</div>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <div className="stat-number">10+</div>
                  <div className="stat-label">Partner Banks</div>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <div className="stat-number">10M+</div>
                  <div className="stat-label">Monthly Transactions</div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="hero-image-wrapper">
                <div className="hero-image-glow"></div>
                <div className="hero-image-container">
                  <img
                    src="https://placehold.co/600x500/0A2540/FFFFFF?text=FORMAX+MONEY+BC+Platform"
                    alt="FORMAX MONEY BC Platform"
                    className="hero-image"
                  />
                </div>

                {/* Floating elements */}
                <div className="floating-element elem-1">
                  <i className="fas fa-coins"></i>
                </div>
                <div className="floating-element elem-2">
                  <i className="fas fa-chart-line"></i>
                </div>
                <div className="floating-element elem-3">
                  <i className="fas fa-hand-holding-usd"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .hero {
          position: relative;
          background: linear-gradient(135deg, #F8F9FC 0%, #EFF2F8 100%);
          padding: 100px 0 80px;
          overflow: hidden;
        }

        /* Background Shapes */
        .hero-bg-shapes {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: 0;
        }

        .shape {
          position: absolute;
          border-radius: 50%;
          opacity: 0.08;
        }

        .shape-1 {
          width: 300px;
          height: 300px;
          background: #D4AF37;
          top: -100px;
          right: -100px;
          animation: float 8s ease-in-out infinite;
        }

        .shape-2 {
          width: 200px;
          height: 200px;
          background: #0A2540;
          bottom: 50px;
          left: -80px;
          animation: float 10s ease-in-out infinite reverse;
        }

        .shape-3 {
          width: 150px;
          height: 150px;
          background: #D4AF37;
          top: 40%;
          left: 20%;
          animation: float 6s ease-in-out infinite;
        }

        .shape-4 {
          width: 100px;
          height: 100px;
          background: #1A3A5F;
          bottom: 20%;
          right: 10%;
          animation: float 7s ease-in-out infinite reverse;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }

        /* Hero Badge */
        .hero-badge {
          display: inline-flex;
          align-items: center;
          background: rgba(212, 175, 55, 0.12);
          padding: 8px 20px;
          border-radius: 40px;
          font-size: 0.85rem;
          font-weight: 600;
          color: #B8860B;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(4px);
          animation: fadeInUp 0.6s ease-out;
        }

        /* Hero Title */
        .hero-title {
          font-size: 3.2rem;
          font-weight: 800;
          color: #0A2540;
          margin-bottom: 1.5rem;
          line-height: 1.2;
          letter-spacing: -0.02em;
          animation: fadeInUp 0.6s ease-out 0.1s both;
        }

        .hero-title .highlight {
          background: linear-gradient(135deg, #D4AF37, #B8960F);
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          position: relative;
        }

        /* Hero Description */
        .hero-description {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #5A6E7E;
          margin-bottom: 2rem;
          animation: fadeInUp 0.6s ease-out 0.2s both;
        }

        .hero-description strong {
          color: #0A2540;
        }

        /* Buttons */
        .hero-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          margin-bottom: 2rem;
          animation: fadeInUp 0.6s ease-out 0.3s both;
        }

        .btn-gold {
          position: relative;
          background: linear-gradient(135deg, #D4AF37 0%, #B8960F 100%);
          color: #0A2540;
          font-weight: 700;
          padding: 14px 32px;
          border-radius: 50px;
          border: none;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
          overflow: hidden;
          z-index: 1;
        }

        .btn-gold:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(212, 175, 55, 0.4);
          color: #0A2540;
        }

        .btn-effect {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          transform: translate(-50%, -50%);
          transition: width 0.4s, height 0.4s;
          z-index: -1;
        }

        .btn-gold:hover .btn-effect {
          width: 300px;
          height: 300px;
        }

        .btn-outline-gold {
          border: 2px solid #D4AF37;
          color: #D4AF37;
          background: transparent;
          padding: 12px 28px;
          border-radius: 50px;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .btn-outline-gold:hover {
          background: #D4AF37;
          color: #0A2540;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(212, 175, 55, 0.2);
        }

        /* Trust Badges */
        .hero-trust-badges {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          margin-bottom: 2rem;
          animation: fadeInUp 0.6s ease-out 0.4s both;
        }

        .trust-badge {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          background: white;
          padding: 6px 16px;
          border-radius: 30px;
          font-size: 0.85rem;
          font-weight: 500;
          color: #0A2540;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
        }

        .trust-badge i {
          color: #D4AF37;
          font-size: 0.9rem;
        }

        .trust-badge:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        /* Hero Stats */
        .hero-stats {
          display: flex;
          align-items: center;
          gap: 2rem;
          padding-top: 1rem;
          border-top: 1px solid rgba(0, 0, 0, 0.08);
          animation: fadeInUp 0.6s ease-out 0.5s both;
        }

        .stat-item {
          text-align: center;
        }

        .stat-number {
          font-size: 1.8rem;
          font-weight: 800;
          font-family: 'Space Grotesk', monospace;
          color: #D4AF37;
          line-height: 1.2;
        }

        .stat-label {
          font-size: 0.75rem;
          color: #5A6E7E;
          font-weight: 500;
        }

        .stat-divider {
          width: 1px;
          height: 40px;
          background: rgba(0, 0, 0, 0.1);
        }

        /* Hero Image */
        .hero-image-wrapper {
          position: relative;
          animation: fadeInRight 0.8s ease-out;
        }

        .hero-image-glow {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 90%;
          height: 90%;
          background: radial-gradient(circle, rgba(212, 175, 55, 0.15) 0%, transparent 70%);
          border-radius: 50%;
          z-index: 0;
        }

        .hero-image-container {
          position: relative;
          z-index: 1;
          border-radius: 30px;
          overflow: hidden;
          box-shadow: 0 30px 50px -20px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease;
        }

        .hero-image {
          width: 100%;
          height: auto;
          display: block;
          transition: transform 0.5s ease;
        }

        .hero-image-container:hover .hero-image {
          transform: scale(1.02);
        }

        /* Floating Elements */
        .floating-element {
          position: absolute;
          width: 50px;
          height: 50px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
          z-index: 2;
          animation: float 3s ease-in-out infinite;
        }

        .floating-element i {
          font-size: 1.3rem;
          color: #D4AF37;
        }

        .elem-1 {
          top: -20px;
          right: 30px;
          animation-delay: 0s;
        }

        .elem-2 {
          bottom: 40px;
          left: -20px;
          animation-delay: 1s;
        }

        .elem-3 {
          top: 40%;
          right: -25px;
          animation-delay: 0.5s;
        }

        /* Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .hero {
            padding: 80px 0 60px;
          }
          
          .hero-title {
            font-size: 2.2rem;
          }
          
          .hero-description {
            font-size: 1rem;
          }
          
          .hero-stats {
            gap: 1rem;
          }
          
          .stat-number {
            font-size: 1.3rem;
          }
          
          .floating-element {
            width: 35px;
            height: 35px;
          }
          
          .floating-element i {
            font-size: 0.9rem;
          }
          
          .shape-1, .shape-2, .shape-3, .shape-4 {
            display: none;
          }
        }

        @media (max-width: 576px) {
          .hero-title {
            font-size: 1.8rem;
          }
          
          .hero-buttons {
            flex-direction: column;
          }
          
          .btn-gold, .btn-outline-gold {
            text-align: center;
          }
          
          .hero-trust-badges {
            justify-content: center;
          }
          
          .hero-stats {
            justify-content: center;
          }
        }
      `}</style>
    </>
  );
};

export default HeroBanner;
